var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dol-price",style:(_vm.defaultStyle)},[_c('span',{staticClass:"dol-price-unit"},[_vm._v(_vm._s(_vm.unit))]),_c('span',{staticClass:"dol-price-int",style:(_vm.intStyle)},[_vm._v(_vm._s(_vm.int))]),_c('span',{staticClass:"dol-price-decimals"},[_vm._v("."+_vm._s(_vm.decimals))])])
}
var staticRenderFns = []

export { render, staticRenderFns }